import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  @Input() properties!: { type: string, message: string }

  onClose(event: MouseEvent) {
    event.preventDefault();
  }

}
